import { Link } from "@mui/material";
import parse from "html-react-parser";
import React, { Component } from "react";
import DocumentIcon from "../resources/icons-document.svg";
import Placeholder from "./layouts/Placeholder";

export default class JobDescriptionContainer extends Component<any, any> {
  static defaultProps = {
    height: 170,
  };
  textContainerRef: any;
  textContentRef: any;

  constructor(props: any) {
    super(props);

    this.state = {
      contentOverflowing: false,
    };

    this.textContainerRef = React.createRef();
    this.textContentRef = React.createRef();

    window.addEventListener("resize", (e) => {
      this.checkIfContentOverflowing();
    });
  }

  componentDidMount() {
    this.checkIfContentOverflowing();
  }

  checkIfContentOverflowing() {
    let containerEl = this.textContainerRef.current;
    let contentEl = this.textContentRef.current;

    this.setState({
      contentOverflowing:
        containerEl !== null &&
        contentEl !== null &&
        contentEl.clientHeight > containerEl.clientHeight,
    });
  }

  render() {
    const { text, onShowMore, height, noDescriptionText, showAllText }: any = this.props;
    const { contentOverflowing }: any = this.state;

    return (
      <div
        className="klayo-jobdesccontainer"
        onClick={contentOverflowing ? onShowMore : null}
        style={{ cursor: contentOverflowing ? "pointer" : "unset" }}
      >
        <div
          ref={this.textContainerRef}
          className="klayo-jobdesccontainer_text"
          style={{
            maxHeight: height ? height + "px" : "none",
            minHeight: height ? height + "px" : "none",
          }}
        >
          <div
            ref={this.textContentRef}
            className="klayo-jobdesccontainer_textcontent"
          >
            {!text || text.length < 1 || text === "<p></p>" ? (
              <Placeholder
                text={noDescriptionText}
                icon={<DocumentIcon />}
                sx={{ marginTop: "32px" }}
              />
            ) : (
              parse(text)
            )}
          </div>
        </div>
        {height && contentOverflowing && (
          <>
            <div className="klayo-jobdesccontainer_fade"></div>
            <Link
              className="klayo-jobdesccontainer_morelink"
              href="#"
              onClick={onShowMore}
            >
              {showAllText}
            </Link>
          </>
        )}
      </div>
    );
  }
}
